import { FormControl, Typography } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import React from 'react';
import type { FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { borderRadius, palette, spaces } from '../../assets/styles/themes/tokens';
import type { ChangePasswordPayload } from '../ChangePasswordSection/ChangePasswordSection';
import LabelledTextField from '../LabelledTextField/LabelledTextField';
import SettingItem from '../SettingItem';

interface PasswordFieldsRendererProps {
	isEditMode: boolean;
	register: () => void;
	errors: FieldErrors<ChangePasswordPayload>;
}

const PasswordFieldsRenderer = ({ isEditMode, register, errors }: PasswordFieldsRendererProps) => {
	const { t } = useTranslation();

	return isEditMode ? (
		<Grid
			container
			direction="column"
			sx={{
				borderRadius: borderRadius.lg,
				border: `1px solid ${palette.elevation.outlined}`,
				padding: spaces.md,
				backgroundColor: palette.background.paperElevation2,
				gap: spaces.xs,
			}}
		>
			<FormControl fullWidth sx={{ gap: spaces.md }}>
				<LabelledTextField
					dataTestId="current-password-input"
					name="currentPassword"
					label={t('Current Password *')}
					placeholder={t('Enter your password')}
					isPasswordTextField
					inputRef={register}
					error={errors.currentPassword}
				/>
				<LabelledTextField
					dataTestId="set-new-password"
					name="newPassword"
					label={t('New Password *')}
					placeholder={t('Minimum 6 characters')}
					inputRef={register}
					error={errors.newPassword}
					isPasswordTextField
				/>
				<LabelledTextField
					dataTestId="confirm-new-password"
					name="newPasswordRepeat"
					label={t('Confirm New Password *')}
					placeholder={t('Minimum 6 characters')}
					inputRef={register}
					error={errors.newPasswordRepeat}
					isPasswordTextField
				/>
			</FormControl>
		</Grid>
	) : (
		<SettingItem title={t('Password')}>
			<Typography>{'******'}</Typography>
		</SettingItem>
	);
};

export default PasswordFieldsRenderer;
